module.exports = __webpack_public_path__ + "images/FR-0c7ebc4b1942da8436ebb70953867def.jpg";